if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.querySelector('.product-media-modal__button--prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.product-media-modal__button--next')?.addEventListener('click', () => this.step(1));

        // The base media-modal closes on any mouse `pointerup` outside the media
        // (see ModalDialog). Stop pointerup from bubbling out of the control bar
        // so the prev/next arrows navigate instead of closing the lightbox. The
        // close button still works via its own `click` handler.
        this.querySelector('.product-media-modal__nav')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
        });

        // Swipe-to-navigate on touch: swipe left → next, swipe right → prev.
        const swipeArea = this.querySelector('.product-media-modal__content');
        let touchStartX = 0;
        let touchStartY = 0;
        swipeArea?.addEventListener(
          'touchstart',
          (event) => {
            touchStartX = event.changedTouches[0].clientX;
            touchStartY = event.changedTouches[0].clientY;
          },
          { passive: true }
        );
        swipeArea?.addEventListener(
          'touchend',
          (event) => {
            const deltaX = event.changedTouches[0].clientX - touchStartX;
            const deltaY = event.changedTouches[0].clientY - touchStartY;
            // Only treat as a swipe when it's mostly horizontal and past a threshold
            if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
              this.step(deltaX < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );

        // Arrow-key navigation while the lightbox is open
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          }
        });
      }

      // The top-level media slides inside the modal content
      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setActiveMedia(this.openedBy.getAttribute('data-media-id'));
      }

      // Move to the previous/next slide, wrapping around the ends
      step(direction) {
        const items = this.mediaItems;
        if (!items.length) return;

        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        const from = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex = (from + direction + items.length) % items.length;
        this.setActiveMedia(items[nextIndex].getAttribute('data-media-id'));
      }

      setActiveMedia(mediaId) {
        const items = this.mediaItems;
        if (!items.length) return;

        items.forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeMedia = items.find((element) => element.classList.contains('active')) || items[0];
        if (!activeMedia) return;

        activeMedia.scrollIntoView({ block: 'center' });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
